<template>
  <section style="text-align: left">
    <div>
      <p class="text-justify">
        <span class="title">Política de Privacidad</span>
        <br />
        <span class="">Fecha última actualización: 13 de Junio del 2022.</span>
      </p>
      <p class="text-justify">
        <span class="title">Objetivo</span>
        <br />
        El objetivo de esta Política de Privacidad es informarle a nuestro
        clientes el uso que realizamos con sus datos de Google Ads que manejamos
        desde este sistema {{ appName }} Metrics, para mantenerlos informados y
        estén lo mas claro posible de cada una de nuestras actividades que
        involucran de una forma u otra algúnos de sus datos.
      </p>

      <p class="text-justify">
        <span class="title">Datos que manejamos</span>
        <br />
        El sistema {{ appName || "" }} Metrics
        <span class="bold"> solo consulta datos de métricas</span> a Google
        através de su su herramienta destinada para los fines: Google Ads API.
        <br />
        No se realiza ninguna otra acción que no sea lectura (read) através de
        este sistema. No creamos, no actualizamos, o eliminamos ningun registro
        de Google.
      </p>

      <p class="text-justify">
        <span class="title">¿Quiénes pueden ver datos que manejamos?</span>
        <br />
        Las métricas que nosotros consultamos de Google solo son visibles para
        cada cliente nuestro en particular, un cliente no puede ver las métricas
        de otro cliente.
        <br />
        Los encargados, administradores del sistema pueden ver de manera global
        todas las métricas.
      </p>

      <p class="text-justify">
        <span class="title">IMPORTANTE:</span>
        <br />
        Nosotros no planeamos manejar y/o manipular otro tipo de datos de
        nuestro usuarios con acciones como crear, editar y/o eliminar en Google
        Ads. Es importante de todas forma que se mantenga revisando esta
        Política de Privacidad periodicamente para que esté actualizado.
      </p>
    </div>
  </section>
</template>
<script>
export default {
  name: "policy-caribe"
};
</script>
<style lang="scss" scoped>
.text-justify {
  text-align: justify;
  padding: 10px;
}

span.bold {
  font-weight: bold;
}

span.title {
  font-weight: bold;
  font-size: 15px;
  padding-bottom: 10px;
}
</style>
